import { callCurationProxy } from "../backend/backendClient";
import { parseJsonOrThrow, readTextOrThrow } from "./helpers";

/**
 * Options for copying a list item
 * @property index - Index of the new item in the target list
 * @property localeId - Locale ID of the new item
 * @property title - Title of the new item
 */
export interface CopyListItemOptions {
    index?: number;
    localeId?: string;
    title?: string;
}

/**
 * Copy a list item to a new list
 * @param itemId
 * @param targetListId
 * @param options
 * @returns {Promise<unknown>}
 */
export const copyListItem = async (
    itemId: number,
    targetListId: string,
    options: CopyListItemOptions = {},
): Promise<unknown> => {
    if (!itemId || !targetListId) {
        throw new Error("copyListItem requires a source item ID and target list ID.");
    }

    const { index = 0, localeId = "", title = "" } = options;
    const searchParams = new URLSearchParams({
        index: String(index),
        localeId,
        title,
    });

    const responseText = await readTextOrThrow(
        await callCurationProxy({
            path: `/list/copy/${itemId}/${targetListId}?${searchParams.toString()}`,
            method: "PUT",
        }),
        "Copy list item (PUT)",
    );

    return responseText ? parseJsonOrThrow<unknown>(responseText, "Copy list item") : null;
};
